const buildEditableNode = (nodeName, attributes, content, propertyPath) => {
  return `<${nodeName} ${attributes}>${content}<span data-prop="${propertyPath}" class="ck-editable-element" data-editable="basic" style="display:none;"></span></${nodeName}>`
}

export default buildEditableNode
